import React, { useState, useEffect } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { SectionTitle, SectionSubtitle } from '../components/SectionTitle';
import ServiceCard from '../components/ServiceCard';
import Carousel from 'react-elastic-carousel';
import Header from '../components/Header';
import { useCompanyData } from '../../shared/contexts/DataContext';
import { useNavigate, useParams } from 'react-router-dom';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import imgProfile from '../../../../../assets/images/templates/profile.jpg';
import { aboutImage, bannerImage } from '../../shared/logic/imagesFns';
import useMyPagination from '../../shared/logic/useMyPagination';
import MyPagination from '../../shared/components/MyPagination';
import { theme } from '../Template';
import useRTL from 'src/hooks/useRTL';
import GetImageDimensions from '../../shared/logic/getImgDimensions';
import * as Components from '../../shared/sections';
import SectionLayout from '../../shared/layout/SectionLayout';
import { textVariant, textClasses } from '../../shared/config';
import { HomeHeader } from '../../Template3/screens/Home';
import '../../shared/styles.css'
import CourseCard from '../components/CourseCard';

const useStyles = makeStyles((theme) => ({
  carousel: {
    position: 'relative',
    '& .rec.re-arrow': {
      position: 'absolute',
      backgroundColor: 'white',
      // zIndex: '10',
      top: '38%',
    },

    '& .rec.rec-slider-container':{
      [theme.breakpoints.between('xs','md')]: {
        position:'absolute',
        overflow:'visible'
      }
    },

    '& .rec.rec-carousel':{
      [theme.breakpoints.between('xs','md')]: {
        position:'relative'
      }
    },

    '& .rec.rec-arrow':{
      [theme.breakpoints.between('xs','md')]: {
        position:'absolute',
        zIndex:7,
        width:'30px',
        minWidth:'30px',
        height:'30px',
        lineHeight:'25px',
        fontSize:'1.2em',
      },
      backgroundColor:'#17C799',
      color:'#fff'
    },

    '& .rec.rec-dot': {
      display: 'none',
    },
    '& .rec.rec-arrow:last-child': {
      [theme.breakpoints.between('xs','md')]: {
        right: '-12px',
      },
      right:0
    },
    '& .rec.rec-arrow:hover': {
      backgroundColor: '#1c8c6f',
    },
    '& .rec.rec-arrow:disabled': {
      visibility: 'hidden',
    },
    // '& .rec.rec-item-wrapper': {
    //   width:'unset !important',
    // },
  },

  carousel2: {
    '& .rec.rec-item-wrapper': {
      padding:'50px 0px 0px 0px !important',
    },

    '& .rec.rec-dot': {
      display: 'none',
    },
    '& .rec.rec-arrow':{
      backgroundColor:'#17C799',
      color:'#fff',
      width:'40px',
      height:'40px',
      lineHeight:'unset',
      minWidth:'40px',
      fontSize:'1.1em',

    },
    '& .rec.rec-arrow:last-child': {
      right: 0,
    },
    '& .rec.rec-arrow:hover': {
      backgroundColor: '#17C799',
    },
    '& .rec.rec-arrow:disabled': {
      visibility: 'hidden',
    },
  },

  serviceTitleDiv:{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingTop:'50px'
  },

  showBtn:{
    color: '#0F467A',
    fontSize: '13px',
    marginLeft: '8px',
    cursor:'pointer',
    fontFamily:'inherit',
  },

  tp:{
    whiteSpace: 'pre-line',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    fontFamily:'inherit'
  },

  descDiv:{
    alignSelf: 'center',
    outline: 'none',
    border: 'none',
    width: '100%',
    margin: '10px 0px',
    borderRadius: '8px',
    boxSizing:"border-box"
  },

  aboutImg:{
    boxShadow: '0px 0px 30px rgb(209,209,209)',
    "-webkit-box-shadow": '0px 0px 30px rgb(209,209,209)',
    "-moz-box-shadow": '0px 0px 30px rgb(209,209,209)'
  }
}));

const Home = () => {
  const { data } = useCompanyData();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t, companyDomain, homepageSections, aboutSectionStyle } = data;
  const handleExploreServices = () => {
    navigate(companyDomain ? '/temp/services' : `/${id}/temp/services`);
  };

  const handleExploreCategories = () => {
    navigate(companyDomain ? '/temp/categories' : `/${id}/temp/categories`);
  };
  const [, , fontFamily] = useRTL('',"Playfair Display, serif");

  const maxServiceShow = data && data.maxDisplayItems ? data.maxDisplayItems : 4;

  useEffect(()=> {
    window.scrollTo(0, 0);
  },[]);

  const ComponentLists = {
    ...Components,
    'About': About,
    'Services': Services,
    'Courses': Courses,
    'Teams': Teams
  };

  const staticProps = {
    headerImage: bannerImage(data),
    headerTitle: data.companyData?.name,

    aboutName: data.companyData?.name,
    aboutImage: aboutImage(data),
    aboutTitle: data?.aboutTitle || '',
    aboutDescription: data.description ? data.description :  data?.companyData?.description,
    arAboutTitle: data?.arAboutTitle || '',
    arAboutDescription: data?.arAboutDescription || '',
    aboutBackgroundColor: aboutSectionStyle && aboutSectionStyle?.backgroundColor ? aboutSectionStyle?.backgroundColor : 'transparent',
    aboutBackgroundImage: aboutSectionStyle && aboutSectionStyle?.backgroundImage ? aboutSectionStyle?.backgroundImage : '',
    aboutBackgroundStyle: aboutSectionStyle && aboutSectionStyle?.backgroundStyle ? aboutSectionStyle?.backgroundStyle : '',
    aboutSectionStyle,
    productDisplayHorizontal: data?.productDisplayHorizontal || false,
    displayDescription: data.displayProductDesc !== undefined ? data.displayProductDesc : true,

    courses: data.courses || [],
    services: data.products || [],
    categories: data.categories || [],
    teamMembers: data.teams || [],
    maxServiceShow,
    handleExploreServices,
    handleExploreCategories,
    fontFamily,
    t,
    data,
  };

  return (
    <>
      <HomeHeader {...staticProps}/>
      {homepageSections?.length ?
        React.Children.toArray(homepageSections.map(v => {
          const _compName = v?.ComponentName;
          const componentName = _compName === "Content" ? `${_compName}${v?.design || 1}` : ['Services','Courses']?.includes(_compName) && v?.design ? `${_compName}${v?.design || 1}` : _compName;
          const DynamicComponent = v.visible ? ComponentLists[componentName] : ComponentLists['EmptyComponent'];
          return <DynamicComponent {...staticProps} contentData={v.content || {}} productType={v.value} />
        }))
      : 
      <>
        <About {...staticProps} />
        <Services {...staticProps} productType='services' />
        <Teams {...staticProps} />
      </>
      }
    </>
  );
};

const _HomeHeader = ({ headerTitle, data }) => {
  const { displayBanner=true,isRTL } = data || {};
  const title = isRTL === 'ar' && data?.arBannerTitle ? data?.arBannerTitle : data?.bannerTitle || headerTitle;
  
  return (
    <Header
      // height="500px"
      image={bannerImage(data)}
      data={data}
      title={title}
      transparencyColor={data.transparentLayer ? `${data.transparentLayer}${data.transparency ? data.transparency : 'B2'}` : '#15476db2'}
      bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
      displayBanner={displayBanner}
      titleColor={data.bannerFontColor}
      page="home"
    />
  );
};

function About({ aboutTitle, aboutName, aboutImage, aboutDescription, arAboutTitle, arAboutDescription, aboutBackgroundColor, aboutBackgroundImage, aboutBackgroundStyle, t, data, aboutSectionStyle }) {
  const isMounted = React.useRef(null);
  const [imageDimensions, setImageDimensions] = React.useState({});
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const matches720 = useMediaQuery('(min-width:720px)');
  const [showLess, setShowLess] = React.useState(true);
  const textLength = 800;
  const classes = useStyles();
  const { isRTL, generalParagraphFontSize, generalParagraphColor } = data || {};
  const [, , fontFamily] = useRTL('',"'Roboto', sans-serif");
  const { titleFormat, titleFontSize, subTitleFontSize, descriptionFontSize, titleFontColor, subTitleFontColor, textFontColor, paddingTop, paddingBottom } = aboutSectionStyle || {};

  const _descriptionFontSize = descriptionFontSize ? descriptionFontSize : generalParagraphFontSize ? generalParagraphFontSize : '16';
  const descFontColor = textFontColor ? textFontColor : generalParagraphColor ? generalParagraphColor : '#000';

  const desc = isRTL === 'ar' && arAboutDescription ? arAboutDescription : aboutDescription;
  const title = isRTL === 'ar' && arAboutTitle ? arAboutTitle : aboutTitle || t && t('companyPage.aboutus');

  React.useEffect(() => {
    function run() {
      isMounted.current = true;
      if(isMounted.current) {
        GetImageDimensions(setImageDimensions, aboutImage);
      }
    };

    run();
    return () => isMounted.current = false;
  }, [aboutImage]);

    return (
      <Box
        // py={5}
        width="100%"
        style={{
        ...(aboutBackgroundStyle === 'image' && aboutBackgroundImage ?
        {
          backgroundImage: `url(${aboutBackgroundImage})`,
          backgroundSize: "cover"
        }
        :
        aboutBackgroundStyle === 'gradient' ? 
        {backgroundImage: aboutBackgroundColor} 
        : {backgroundColor: aboutBackgroundColor}
        )
      }}
      >
      <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
        <Box
          m="auto"
          width="100%"
          display="flex"
          flexWrap="wrap"
          alignItems="center"
          justifyContent={matches720 ? 'space-between' : 'center' }
        >
          <Box width={matches720 ? '49%' : '100%'} pb={2} textAlign={!matches720 ? 'center' : 'initial'}>
            <Box pb={3}>
              <SectionSubtitle pFontSize={subTitleFontSize} color={subTitleFontColor}>{t && t('companyPage.aboutus')}</SectionSubtitle>
              <SectionTitle pFontSize={titleFontSize} color={titleFontColor} variant={titleFormat || ''}>{title}</SectionTitle>
            </Box>
              <Typography
                color={descFontColor}
                variant={_descriptionFontSize && textVariant?.[_descriptionFontSize] ? textVariant?.[_descriptionFontSize] : textVariant?.['16']}
                className={`${_descriptionFontSize && textClasses?.[_descriptionFontSize] ? textClasses?.[_descriptionFontSize] : textClasses?.['16']} ${classes.descDiv}`}
              >
                {desc && desc.length < textLength ?
                  <span className={classes.tp} style={{fontSize:'inherit'}}>{desc}</span>
                :
                showLess ?
                  <>
                  <span className={classes.tp} style={{fontSize:'inherit'}}>{desc && desc.slice(0,textLength)}</span>
                  <span className={classes.showBtn} style={{fontFamily:'inherit'}} onClick={()=> setShowLess(false)}>{t && t('companyPage.showmore')}</span>
                  </>
                :
                  <>
                  <span variant="body1" className={classes.tp} style={{fontSize:'inherit'}}>{desc}</span>
                  <span className={classes.showBtn} style={{fontFamily:'inherit'}} onClick={()=> setShowLess(true)}>{t && t('companyPage.showless')}</span>
                  </>
                }
              </Typography>
          </Box>
          {aboutImage && (
            <Box
              width="auto"
              maxWidth='45%'
              height="auto"
              maxHeight="504px"
              overflow="hidden"
              borderRadius="15px"
              className={classes.aboutImg}
            >
              <ImgLazyLoad>
                <img
                  style={{
                    width:"100%",
                    // maxWidth: matches720 ? '350px' : "400px",
                    height:"auto",
                    maxHeight: "504px",
                    borderRadius:"15px",
                    ...(imageDimensions?.height >= 1280 ? {objectFit:'cover'} : {})
                  }}
                  src={data.aboutImage ? data.aboutImage : aboutImage}
                  alt={aboutName || 'about'}
                />
              </ImgLazyLoad>
            </Box>
          )}
        </Box>
      </SectionLayout>
      </Box>
    );
}

function Services({ services, categories, t, handleExploreServices, handleExploreCategories, productType, data, contentData, fontFamily }) {
  const isMounted = React.useRef(null);
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const { maxDisplayItems, displayProductDesc, productDisplayHorizontal = true, backgroundColor, backgroundImage, backgroundStyle, categoryId, title, arTitle, subTitle, arSubTitle, selectedCategories, titleFormat, titleFontSize, subTitleFontSize, titleFontColor, subTitleFontColor, paddingTop, paddingBottom } = contentData || {};
  const displayDescription = displayProductDesc !== undefined ? displayProductDesc : true;
  const maxServiceShow = maxDisplayItems ? maxDisplayItems : 4;
  const [showItems,setItems] = useState(4);
  const { buttonColor,buttonFontColor, isRTL } = data || {};
  const classes = useStyles();
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 900, itemsToShow: 2 },
    { width: 1000, itemsToShow: 3 },
  ];
  const _title = title ? (isRTL === 'ar' ? (arTitle ? arTitle : title) : title) : productType === 'categories' ? t && t('companyPage.category') : t && t('companyPage.services');
  const _subTitle = subTitle ? (isRTL === 'ar' ? (arSubTitle ? arSubTitle : subTitle) : subTitle) : t && t('companyPage.letsStartLearning');


  const servicesDuplicate = services?.length ? JSON.parse(JSON.stringify(services)) : [];
  const filterService = servicesDuplicate?.length && categoryId && servicesDuplicate.filter(v=> v.serviceCategoryId === categoryId)?.length ? 
  servicesDuplicate.filter(v=> v.serviceCategoryId === categoryId) : 
  servicesDuplicate;

  React.useEffect(() => {
    isMounted.current = true;

    setItems(maxServiceShow)
    return () => isMounted.current = false;
  }, [maxServiceShow]);

  const companyId = data.companyData ? data.companyData.companyId : '';
  const filteredSelectedCategory = selectedCategories?.length && categories ?  categories?.filter(category => selectedCategories.includes(category.id)) : [];
  const renderList = productType === 'categories' ? selectedCategories?.length && filteredSelectedCategory?.length ? filteredSelectedCategory : categories : filterService;
  const filterCategories = filteredSelectedCategory?.length ? filteredSelectedCategory : categories;

  const [, , buttonFontFamily] = useRTL('',"'Roboto', sans-serif");

  function RenderItems() {
    return(
      productType === 'categories' ?
      filterCategories?.slice(0, maxServiceShow).map((item, i) => (
          <ServiceCard key={i} service={item} {...{displayDescription,productType,companyId,contentData}} />
        ))
      :
        filterService?.slice(0, maxServiceShow).map((item, i) => (
          <ServiceCard key={i} service={item} {...{displayDescription,companyId,contentData}} />
        ))
    )
  };
  if(filterService.length > 0 || filterCategories.length > 0){
    return (
      <Box
        style={{
          width:'100%',
          // paddingBottom:'100px',
          ...(backgroundStyle === 'image' && backgroundImage ?
            {
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundRepeat: 'no-repeat',
            }
            :
            backgroundStyle === 'gradient' ? 
            {backgroundImage: backgroundColor} 
            : {backgroundColor: backgroundColor || 'transparent'}
          )
        }}
      >
        <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
          <Box width="100%" m="auto">
            <Box pb={3} className={classes.serviceTitleDiv} style={!matches ? {textAlign:'center',display:'unset'} : {}}>
              <Box style={!matches ? {paddingBottom:'24px'} : {}}>
                <SectionSubtitle pFontSize={subTitleFontSize} color={subTitleFontColor} style={data.isRTL === 'ar' ? {paddingBottom:'15px'} : {}}>{_title}</SectionSubtitle>
                <SectionTitle pFontSize={titleFontSize} color={titleFontColor} variant={titleFormat || ''} style={data.isRTL === 'ar' ? {paddingBottom:'15px'} : {}}>{_subTitle}</SectionTitle>
              </Box>
              {/* {matches && productType === 'services' ? (
              <Box textAlign="center">
                <Button
                  onClick={productType === 'categories' ? handleExploreCategories : handleExploreServices}
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{fontFamily:buttonFontFamily,backgroundColor: buttonColor ? buttonColor : 'inherit',color:buttonFontColor ? buttonFontColor : 'inherit'}}
                >
                  {t && productType === 'categories' ? t('companyPage.expendCategories') : t('companyPage.exploreServices')}
                </Button>
              </Box>
              )
              : null } */}
            </Box>
        
            <Box pb={3} display="flex" flexDirection={!productDisplayHorizontal ? 'row' : 'unset'} flexWrap={!productDisplayHorizontal ? 'wrap' : 'unset'} justifyContent={!matches ? "center" : renderList?.length <=2 ? 'center' :"space-between"}>
              {!productDisplayHorizontal ?
                  <RenderItems />
                :
                <Carousel className={classes.carousel} breakPoints={breakPoints}>
                  {
                    productType === 'categories' ?
                    filterCategories?.slice(0, maxServiceShow).map((item, i) => (
                      <ServiceCard key={i} service={item} {...{displayDescription,productType,companyId,contentData}} />
                    ))
                  :
                    filterService?.slice(0, maxServiceShow).map((item, i) => (
                      <ServiceCard key={i} service={item} {...{displayDescription,companyId,contentData}} />
                    ))
                  }
                </Carousel>
              }
            </Box>
          </Box>
        </SectionLayout>
        {/* <Box pb={4} textAlign="center">
          <Button
            onClick={productType === 'categories' ? handleExploreCategories : handleExploreServices}
            variant="contained"
            color="primary"
            size="large"
            style={{fontFamily:buttonFontFamily,backgroundColor:buttonColor ? buttonColor : 'inherit', color: buttonFontColor ? buttonFontColor : 'inherit'}}
          >
            {t && t('companyPage.exploreServices')}
          </Button>
        </Box> */}
      </Box>
    );
  }

  return null;
}

function Courses({ courses, t, data, contentData }) {
  const isMounted = React.useRef(null);
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const { maxDisplayItems, displayProductDesc, productDisplayHorizontal = true, backgroundColor, backgroundImage, backgroundStyle, categoryId, title, arTitle, subTitle, arSubTitle, titleFormat, titleFontSize, subTitleFontSize, titleFontColor, subTitleFontColor, paddingTop, paddingBottom } = contentData || {};
  const displayDescription = displayProductDesc !== undefined ? displayProductDesc : true;
  const maxServiceShow = maxDisplayItems ? maxDisplayItems : 4;
  const [showItems,setItems] = useState(4);
  const { buttonColor,buttonFontColor, isRTL } = data || {};
  const classes = useStyles();
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 900, itemsToShow: 2 },
    { width: 1000, itemsToShow: 3 },
  ];

  const _title = title ? (isRTL === 'ar' ? (arTitle ? arTitle : title) : title) : t && t('courses.title');
  const _subTitle = subTitle ? (isRTL === 'ar' ? (arSubTitle ? arSubTitle : subTitle) : subTitle) : t && t('companyPage.letsStartLearning');

  const coursesDuplicate = courses?.length ? JSON.parse(JSON.stringify(courses)) : [];
  const filterCourses = coursesDuplicate?.length && categoryId && coursesDuplicate.filter(v=> v.courseCategoryId === categoryId)?.length ? 
  coursesDuplicate.filter(v=> v.courseCategoryId === categoryId) : 
  coursesDuplicate;

  React.useEffect(() => {
    isMounted.current = true;

    setItems(maxServiceShow)
    return () => isMounted.current = false;
  }, [maxServiceShow]);

  const companyId = data.companyData ? data.companyData.companyId : '';
  const renderList = filterCourses;

  const [, , buttonFontFamily] = useRTL('',"'Roboto', sans-serif");

  function RenderItems() {
    return(
      filterCourses?.slice(0, maxServiceShow).map((item, i) => (
        <CourseCard key={i} service={item} {...{displayDescription,companyId,contentData}} />
      ))
    )
  };
  if(filterCourses.length > 0){
    return (
      <Box
        style={{
          width:'100%',
          ...(backgroundStyle === 'image' && backgroundImage ?
            {
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundRepeat: 'no-repeat',
            }
            :
            backgroundStyle === 'gradient' ? 
            {backgroundImage: backgroundColor} 
            : {backgroundColor: backgroundColor || 'transparent'}
          )
        }}
      >
        <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
        <Box width="100%" m="auto">
          <Box pb={3} className={classes.serviceTitleDiv} style={!matches ? {textAlign:'center',display:'unset'} : {}}>
            <Box style={!matches ? {paddingBottom:'24px'} : {}}>
              <SectionSubtitle pFontSize={subTitleFontSize} color={subTitleFontColor} style={data.isRTL === 'ar' ? {paddingBottom:'15px'} : {}}>{_title}</SectionSubtitle>
              <SectionTitle pFontSize={titleFontSize} color={titleFontColor} variant={titleFormat || ''} style={data.isRTL === 'ar' ? {paddingBottom:'15px'} : {}}>{_subTitle}</SectionTitle>
            </Box>
          </Box>
      
          <Box pb={3} display="flex" flexDirection={!productDisplayHorizontal ? 'row' : 'unset'} flexWrap={!productDisplayHorizontal ? 'wrap' : 'unset'} justifyContent={!matches ? "center" : renderList?.length <=2 ? 'center' :"space-between"}>
            {!productDisplayHorizontal ?
                <RenderItems />
              :
              <Carousel className={classes.carousel} breakPoints={breakPoints}>
                {
                  filterCourses?.slice(0, maxServiceShow).map((item, i) => (
                    <CourseCard key={i} service={item} {...{displayDescription,companyId,contentData}} />
                  ))
                }
              </Carousel>
            }
          </Box>
        </Box>
        </SectionLayout>
      </Box>
    );
  }

  return null;
}

function Teams({ teamMembers, headerImage, t, data,fontFamily, contentData }) {
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const classes = useStyles();
  const { setPage, count, currentItems } = useMyPagination(
    teamMembers,
    matches ? 4 : 1
  );
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 900, itemsToShow: 2 },
    { width: 1000, itemsToShow: 3 },
  ];
  const transparencyColor = data.transparentLayer ? `${data.transparentLayer}${data.transparency ? data.transparency : 'B2'}` : '#15476db2'
  const { backgroundColor, backgroundImage, backgroundStyle, titleFormat, titleFontSize, subTitleFontSize, titleFontColor, subTitleFontColor, paddingTop, paddingBottom } = contentData || {};

  if(teamMembers?.length)
  return (
    <div
      style={{
        width:'100%',
        ...(backgroundStyle === 'image' && backgroundImage ?
          {
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundRepeat: 'no-repeat',
          }
          :
          backgroundStyle === 'gradient' ? 
          {backgroundImage: backgroundColor} 
          : 
          {backgroundColor: backgroundColor || 'transparent'}
        )
      }}
    >
      <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
      <Box width="100%" m="auto">
        <Box textAlign="center">
          <SectionSubtitle pFontSize={subTitleFontSize} color={subTitleFontColor}>{t && t('companyPage.team')}</SectionSubtitle>
          <SectionTitle pFontSize={titleFontSize} color={titleFontColor || 'white'} variant={titleFormat || ''}>
            {t && t('companyPage.meetOurTeam')}
          </SectionTitle>
        </Box>

        <Box display="flex" justifyContent="center" pt={10} width="100%">
        {matches ? (
          <Carousel className={classes.carousel2} breakPoints={breakPoints}>
            {currentItems?.map((item, i) => (
              <TeamMember key={i} member={item} data={data} />
            ))}
          </Carousel>
        )
        :
          currentItems?.map((item, i) => (
            <TeamMember key={i} member={item} data={data} />
          ))
        }
        </Box>
        {!matches ? <MyPagination color="white" count={count} onChange={setPage} /> : null }
      </Box>
      </SectionLayout>
    </div>
  );

  return null;
}

const TeamMember = ({ member, data }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {companyDomain} = data || {};
  
  const handleClick = (_id) => {
    navigate(companyDomain ? `/temp/team/${_id}` : `/${id}/temp/team/${_id}`);
  };

  return (
    <Box
      boxShadow="0 0 30px rgb(187, 187, 187)"
      bgcolor="white"
      borderRadius="10px"
      overflow="visible"
      mr={2}
      mb={2}
      style={{cursor:"pointer"}}
      onClick={()=> handleClick(member?.id)}
    >
      <Box height="180px" position="relative" width="250px">
        <Box
          position="absolute"
          top="-25%"
          left="50%"
          style={{ transform: 'translateX(-50%)' }}
          width="100px"
          height="100px"
          border="2px solid #17C799"
          borderRadius="50%"
        >
          <ImgLazyLoad>
            <img
              style={{ width: '100%', height:'100%', borderRadius: '50%' }}
              src={member?.avatar || imgProfile}
              alt={member.name || 'team'}
            />
          </ImgLazyLoad>
        </Box>
        <Box
          height="100%"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          pt={2}
        >
          <Box py={1}>
          <Typography variant="subtitle1" style={{ padding: '0 1em',fontWeight:'bold',textTransform:'capitalize' }}>
            {member.name}
          </Typography>
          </Box>
          <Typography
            variant="subtitle2"
            color="textSecondary"
            style={{ textTransform: 'capitalize',fontFamily:'inherit'}}
          >
            {member.roleType}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export {
  About,
  Services,
  Courses,
  Teams,
  _HomeHeader
};

export default Home;
